import React from 'react';

import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button} from 'reactstrap';
import ResultGroup from "./ResultGroup";

class AdContactCluster {
    constructor(ad) {
        this.ad = ad;
        this.contacts = [];
    }

    getAd() {
        return this.ad;
    }

    addContact(contact) {
        this.contacts.push(contact);
    }

    getContacts() {
        return this.contacts;
    }
}

class ResultList extends React.Component {
    static propTypes = {
        contacts: PropTypes.array.isRequired,
        totalContacts: PropTypes.number.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired
    };

    breakdownContactsByAds(contacts) {
        const contactsClusteredByAds = [];

        let currentAdCluster = null;
        let currentAdId = null;
        if (contacts && contacts.length > 0) {
            contacts.forEach((contact) => {
                if (!currentAdId || currentAdId !== contact.ad.id || !currentAdCluster) {
                    currentAdId = contact.ad.id;

                    currentAdCluster = new AdContactCluster(contact.ad);
                    contactsClusteredByAds.push(currentAdCluster);
                }

                currentAdCluster.addContact(contact);
            });
        }

        return contactsClusteredByAds;
    }

    render() {
        const {contacts, totalContacts, onLoadMoreContacts} = this.props;

        const contactsBrokenDownByAds = this.breakdownContactsByAds(contacts);

        if (!contacts || contacts.length === 0) {
            return <div className="error-container">
                <h2>
                    <FormattedMessage id="catalogue.no_results" defaultMessage="No results have been found" />
                </h2>
            </div>
        }

        return <div className="conv__list conv__list--result">
            { contactsBrokenDownByAds.map((adContactCluster, index) => {
                return <ResultGroup key={"cluster-" + index} adContactCluster={adContactCluster}/>
            })}
            {contacts.length < totalContacts &&
            <Button className="btn-clickable" onClick={onLoadMoreContacts}>
                <FormattedMessage id="stats.load_more" defaultMessage="Load more"/>
            </Button>
            }
        </div>
    }
}

export default ResultList;


// WEBPACK FOOTER //
// ./src/containers/Catalogue/ResultList/index.jsx